import React from "react";
import PropTypes from "prop-types";
import CustomButton from "../../common/CustomButton";
import { getBackgroundClass, interestLevel } from "../../../Enum/LeadEnumConstants";

const BulkLeadUploadHistoryForm = ({ formData, onViewLeads, onRevertLeads }) => {

  const displayDate = formData.dateAndTime || "N/A";


  const isRevertAllowed = () => {
    const uploadTime = new Date(
      Date.parse(
        displayDate.replace(/(\d{2})\/(\d{2})\/(\d{4}), (\d{2}:\d{2}:\d{2} [ap]m)/, "$3-$2-$1 $4")
      )
    );
    const now = new Date();
    const hoursDiff = (now - uploadTime) / (1000 * 60 * 60);
    return hoursDiff <= 3;

  };



  return (
    <div className="p-4 space-y-6">
      <div className="grid grid-cols-1 gap-4  sm:gap-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center">
          <label htmlFor="batchId" className="text-sm font-medium text-gray-700 w-full sm:w-[200px]">
            ID
          </label>
          <input
            id="batchId"
            type="text"
            value={formData.batchId || ""}
            readOnly
            className="rounded-[10px] p-2 border border-gray-300 bg-gray-100 w-full focus:outline-none"
            placeholder="N/A"
          />
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center">
          <label htmlFor="createdBy" className="text-sm font-medium text-gray-700 w-full sm:w-[200px]">
            Uploaded By
          </label>
          <input
            id="createdBy"
            type="text"
            value={formData.createdBy || ""}
            readOnly
            className="rounded-[10px] p-2 border border-gray-300 bg-gray-100 w-full focus:outline-none"
            placeholder="N/A"
          />
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center">
          <label htmlFor="leadQuality" className="text-sm font-medium text-gray-700 w-full sm:w-[200px]">
            Lead Quality
          </label>
          <div
            id="leadQuality"
            className={`rounded-[10px] p-2 border border-gray-300 bg-gray-100 w-full ${getBackgroundClass(
              formData.leadQuality
            )} font-bold`}
          >
           <div className="flex items-center gap-2">
           <img src={interestLevel.find((item)=> item.label === formData.leadQuality)?.image} className="w-5 h-5" alt="icon" />
           <div>{formData.leadQuality || "N/A"}</div>
           </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center">
          <label htmlFor="leadSource" className="text-sm font-medium text-gray-700 w-full sm:w-[200px]">
            Lead Source
          </label>
          <input
            id="leadSource"
            type="text"
            value={formData.leadSource || ""}
            readOnly
            className="rounded-[10px] p-2 border border-gray-300 bg-gray-100 w-full focus:outline-none"
            placeholder="N/A"
          />
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center">
          <label htmlFor="totalLead" className="text-sm font-medium text-gray-700 w-full sm:w-[200px]">
            Total Leads
          </label>
          <input
            id="totalLead"
            type="number"
            value={formData.totalLead || 0}
            readOnly
            className="rounded-[10px] p-2 border border-gray-300 bg-gray-100 w-full focus:outline-none"
            placeholder="0"
          />
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center">
          <label htmlFor="validLead" className="text-sm font-medium text-gray-700 w-full sm:w-[200px]">
            Uploaded Leads
          </label>
          <input
            id="validLead"
            type="number"
            value={formData?.totalLead - (formData?.duplicateLeadInFile + formData?.duplicateLeadInDb + formData?.invalidLead) || 0}
            readOnly
            className="rounded-[10px] p-2 border border-gray-300 bg-gray-100 w-full focus:outline-none"
            placeholder="0"
          />
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center">
          <label htmlFor="duplicateLead" className="text-sm font-medium text-gray-700 w-full sm:w-[200px]">
            Duplicate Leads In File
          </label>
          <div className="w-full">
            <input
              id="duplicateLead"
              type="number"
              value={formData.duplicateLeadInFile || 0}
              readOnly
              className="rounded-[10px] p-2 border border-gray-300 bg-gray-100 w-full focus:outline-none"
              placeholder="0"
            />
            {formData.duplicateLeadInFile > 0 && (
              <div className="mt-2 p-2 bg-red-100 text-red-600 rounded-[10px] text-sm">
                Error: This batch contains {formData.duplicateLeadInFile} duplicate leads in file.
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center">
          <label htmlFor="duplicateLead" className="text-sm font-medium text-gray-700 w-full sm:w-[200px]">
            Duplicate Leads In Database
          </label>
          <div className="w-full">
            <input
              id="duplicateLead"
              type="number"
              value={formData.duplicateLeadInDb || 0}
              readOnly
              className="rounded-[10px] p-2 border border-gray-300 bg-gray-100 w-full focus:outline-none"
              placeholder="0"
            />
            {formData.duplicateLeadInDb > 0 && (
              <div className="mt-2 p-2 bg-red-100 text-red-600 rounded-[10px] text-sm">
                Error: This batch contains {formData.duplicateLeadInDb} duplicate leads in database
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center">
          <label htmlFor="invalidLead" className="text-sm font-medium text-gray-700 w-full sm:w-[200px]">
            Invalid Leads
          </label>
          <div className="w-full">
            <input
              id="invalidLead"
              type="number"
              value={formData.invalidLead || 0}
              readOnly
              className="rounded-[10px] p-2 border border-gray-300 bg-gray-100 w-full focus:outline-none"
              placeholder="0"
            />
            {formData.invalidLead > 0 && (
              <div className="mt-2 p-2 bg-red-100 text-red-600 rounded-[10px] text-sm">
                Error: This batch contains {formData.invalidLead} invalid leads.
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center">
          <label htmlFor="assignedTeam" className="text-sm font-medium text-gray-700 w-full sm:w-[200px]">
            Assigned Team
          </label>
          <input
            id="assignedTeam"
            type="text"
            value={formData.assignedTeam || ""}
            readOnly
            className="rounded-[10px] p-2 border border-gray-300 bg-gray-100 w-full focus:outline-none"
            placeholder="N/A"
          />
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center">
          <label htmlFor="assignedUser" className="text-sm font-medium text-gray-700 w-full sm:w-[200px]">
            Assigned User
          </label>
          <input
            id="assignedUser"
            type="text"
            value={formData.assignedUser || ""}
            readOnly
            className="rounded-[10px] p-2 border border-gray-300 bg-gray-100 w-full focus:outline-none"
            placeholder="N/A"
          />
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center">
          <label htmlFor="dateAndTime" className="text-sm font-medium text-gray-700 w-full sm:w-[200px]">
            Upload Date & Time
          </label>
          <input
            id="dateAndTime"
            type="text"
            value={displayDate}
            readOnly
            className="rounded-[10px] p-2 border border-gray-300 bg-gray-100 w-full focus:outline-none"
            placeholder="N/A"
          />
        </div>
      </div>

      <div className="flex flex-col  justify-between items-start sm:items-center mt-6 gap-4">
       <div className="flex flex-col gap-4 w-full">
        {
          (formData.totalLead - (formData.duplicateLeadInDb + formData.duplicateLeadInFile ) !== 0) && (
            <CustomButton label="View Uploaded Leads" onClick={() => onViewLeads(formData.batchId)} className={"flex justify-center w-full"} />
          )
        }
        {/* <div className="flex flex-col w-full items-start sm:items-center gap-4">
          <CustomButton
            label="Revert Leads"
            onClick={() => onRevertLeads(formData.batchId)}
            disabled={!isRevertAllowed()}
            className={   isRevertAllowed() ? "flex justify-center w-full " : " flex justify-center w-full opacity-50 cursor-not-allowed"}

          />
          <div className="text-sm text-gray-600">
            <span className="text-red-500 font-medium">Note:</span> Revert is only allowed within 3 hours of upload.
          </div>
        </div> */}
       </div>
      </div>
    </div>
  );
};





export default BulkLeadUploadHistoryForm;